<template>
  <div class="nav-list-subheader">
    <slot>{{ title }}</slot>
  </div>
</template>

<script>
export default {
  name: 'NavListSubheader',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../scss/variables' as *;

.nav-list-subheader {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: $spacing-3 $spacing-3 $spacing-1;
  margin: $spacing-1 $spacing-2 0;
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.08em;

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, #e2e8f0 0%, transparent 100%);
  }
}
</style>
